<template>
	<v-row no-gutters>
		<v-col cols="2">
			<small>
				{{ $t("Code") }}
			</small>
			<p class="pt-2 font-weight-medium">#{{ order.code }}</p>
		</v-col>
		<v-col cols="4">
			<small>
				{{ $t("Datetime") }}
			</small>
			<v-chip small outlined color="black">
				<time-ago
					:datetime="order.datetime"
					:refresh="1"
					long
					tooltip
					style="color: red; border-color: red; font-size: 18px"
				>
				</time-ago
			></v-chip>
			<p class="pt-2 font-weight-medium">
				{{ order.date }} @
				{{ order.time }}
			</p>
		</v-col>
		<v-col cols="2">
			<small>
				{{ $t("Outlet") }}
			</small>
			<p class="pt-2 font-weight-medium">
				{{ order.outlet ? order.outlet.name : null }}
			</p>
		</v-col>
		<v-col cols="2">
			<small>
				{{ $t("Amount") }}
			</small>
			<p class="pt-2 font-weight-medium">
				{{ order.total }}
				<v-chip color="black" dark x-small>
					{{ order.payment_method_code }}
				</v-chip>
			</p>
		</v-col>
		<v-col cols="1">
			<small>
				{{ $t("Type") }}
			</small>
			<p class="pt-2 font-weight-medium">
				<v-chip color="black" dark x-small> {{ order.type }}</v-chip>
			</p>
		</v-col>
		<v-col cols="12" v-if="open">
			<v-divider></v-divider>
		</v-col>
	</v-row>
</template>

<script>
import "vue2-timeago/dist/vue2-timeago.css";
import { TimeAgo } from "vue2-timeago";
export default {
	props: ["order", "open"],
	components: {
		TimeAgo,
	},
};
</script>